import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import classes from "./modules/classes";
import form from "./modules/form";
import filter from "./modules/filter";
import classDayAndTime from "./modules/class-day-and-time";
import student from "./modules/student";
import classTemp from "./modules/class-temp";
import lecturer from "./modules/lecturer";
import scoreType from "./modules/score-type";
import score from "./modules/score";
import dashboard from "./modules/dashboard";
import classStatus from "./modules/class-status";
import event from "./modules/event";
import eventCategory from "./modules/event-category";
import eventType from "./modules/event-type";
import notice from "./modules/notice";
import noticeType from "./modules/notice-type";
import job from "./modules/job";
import applicationPurpose from "./modules/application-purpose";
import eventStudentMessage from "./modules/event-student-message";
import video from "./modules/video";
import videoCategory from "./modules/video-category";
import tag from "./modules/tag";
import eventStudentMessageStatus from "./modules/event-student-message-status";
import eventStudentMessageAction from "./modules/event-student-message-action";
import attendance from "./modules/attendance";
import classPerson from "./modules/class-person";
import lecturerAvailability from "./modules/lecturer-availability";
import zoom from "./modules/zoom";
import sts from "./modules/sts";
import project from "./modules/project";
import userStsTemp from "./modules/user-sts-temp";
import reports from "./modules/reports";
import classType from "./modules/class-type";
import classEndType from "./modules/class-end-type";
import certificate from "./modules/certificate";
import participation from "./modules/participation";
import centerPerson from "./modules/center-person";
import settings from "./modules/settings";
import classZoom from "./modules/class-zoom.";
import extended from "./modules/extended";
import classTemplate from "./modules/class-template";
import preRegistration from "./modules/pre-registration";
import sso from "./modules/sso";
import userAddress from "./modules/user-address";
import contract from "./modules/contract";
import paymentRecovery from "./modules/paymentRecovery";

import studentPayment from "./modules/student-payment";

import playlist from "./modules/playlist";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    //sso
    sso: sso,

    class: classes,
    form: form,
    auth: auth,
    filter: filter,
    classDayAndTime: classDayAndTime,
    student: student,
    classTemp: classTemp,
    lecturer: lecturer,
    scoreType: scoreType,
    score: score,
    attendance: attendance,
    dashboard: dashboard,
    classStatus: classStatus,
    classPerson: classPerson,
    paymentRecovery: paymentRecovery,

    //Events
    event: event,
    eventCategory: eventCategory,
    eventType: eventType,
    eventStudentMessage: eventStudentMessage,
    eventStudentMessageStatus: eventStudentMessageStatus,
    eventStudentMessageAction: eventStudentMessageAction,

    notice: notice,
    noticeType: noticeType,
    job: job,
    applicationPurpose: applicationPurpose,

    //Videos
    video: video,
    videoCategory: videoCategory,

    //tag
    tag: tag,

    //Lecturers
    lecturerAvailability: lecturerAvailability,

    //Zoom
    zoom: zoom,

    //STS
    sts: sts,

    //Project
    project: project,

    userStsTemp: userStsTemp,

    reports: reports,

    classType: classType,
    classEndType: classEndType,
    certificate: certificate,
    participation: participation,

    centerPerson: centerPerson,

    settings: settings,

    classZoom: classZoom,

    //extended
    extended: extended,

    //class templates
    classTemplate: classTemplate,

    //register
    preRegistration: preRegistration,
    userAddress: userAddress,

    //contracts
    contract: contract,

    userStudentPayment: studentPayment,

    playlist: playlist,
  },

  state: {
    Sidebar_drawer: null,
    Customizer_drawer: false,
    SidebarColor: "#1d2228", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "white",
    setHorizontalLayout: false, // Horizontal layout

    snackbarData: {
      snackbarStatus: false,
      snackbarColor: "yee",
      snackbarText: "",
      snackbarIcon: "mdi-check",
      isSuccess: true,
    },
    progressbarData: {
      progressbarStatus: false,
    },

    pagination: {
      pageRows: [1, 2, 5, 10, 15, 20, 50, 100, 500, 1000],
      co: {
        pageSize: 10,
        pageIndex: 0,
        centerId: null,
        centerPeriodId: null,
      },
      totalRecords: 0,
      totalPages: 0,
    },
  },

  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },

    addSnackBarMutation(state, data) {
      state.snackbarData = data;
    },
    addProgressbarMutation(state, data) {
      state.progressbarData = data;
    },

    setPagination(state, payload) {
      if (JSON.stringify(state.pagination?.co != JSON.stringify(payload.co))) {
        state.pagination.co = payload.co;
      }
    },

    setPaginationTotals(state, payload) {
      state.pagination = payload;
    },
  },

  actions: {
    changeDarkMode(vuexContext, data) {
      localStorage.setItem("theme-dark-mode", JSON.stringify(data));
    },
    changeRtlMode(vuexContext, data) {
      localStorage.setItem("rtl", JSON.stringify(data));
    },
    changeThemeColor(vuexContext, data) {
      localStorage.setItem("theme_color", JSON.stringify(data));
    },

    getDarkModeFromLocal() {
      if (localStorage.getItem("theme-dark-mode")) return JSON.parse(localStorage.getItem("theme-dark-mode"));
      else {
        localStorage.setItem("theme-dark-mode", JSON.stringify(false));
        return false;
      }
    },
    getRtlModeFromLocal() {
      if (localStorage.getItem("rtl")) return JSON.parse(localStorage.getItem("rtl"));
      else {
        localStorage.setItem("rtl", JSON.stringify(false));
        return false;
      }
    },
    getThemeColorFromLocal() {
      //Eğer değer yoksa hata vermemesi için kontrol ediyoruz.
      return localStorage.getItem("theme_color") ? JSON.parse(localStorage.getItem("theme_color")) : null;
    },

    addSnackBarAction(vuexContext, data) {
      vuexContext.commit("addSnackBarMutation", data);
    },

    async addPagination(vuexContext, data) {
      await vuexContext.commit("setPagination", data);
    },

    async clearPagination(vuexContext) {
      let pagination = vuexContext.state.pagination;
      if (pagination && pagination.co && Object.getOwnPropertyNames(pagination.co).length > 0) {
        let properties = Object.getOwnPropertyNames(pagination.co);
        for await (let element of properties) {
          if (element != "pageIndex" && element != "pageSize" && element != "centerId" && element != "centerPeriodId") delete pagination.co[element];
        }
      }
      await vuexContext.commit("setPagination", pagination);
    },

    async addPaginationTotals(vuexContext, data) {
      await vuexContext.commit("setPaginationTotals", data);
    },

    loadSnackbarSuccess(vuexContext, message) {
      let snackbarData = {
        snackbarStatus: true,
        snackbarColor: "primary",
        snackbarText: message,
        snackbarIcon: "mdi-check",
        isSuccess: true,
      };
      vuexContext.commit("addSnackBarMutation", snackbarData);
    },

    loadSnackbarError(vuexContext, message) {
      let snackbarData = {
        snackbarStatus: true,
        snackbarColor: "accent_darken",
        snackbarText: message,
        snackbarIcon: "mdi-close",
        isSuccess: false,
      };
      vuexContext.commit("addSnackBarMutation", snackbarData);
    },

    loadProgressbarAction(vuexContext, value) {
      let progressData = {
        progressbarStatus: value,
      };
      vuexContext.commit("addProgressbarMutation", progressData);
    },
  },

  getters: {},
});
